import React, { useContext } from "react";
import { UserContext } from "../providers/UserProvider";
import { auth } from "../firebase";
import { withRouter } from "react-router-dom";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import { ExitToApp, Dashboard } from "@material-ui/icons";
import { palette } from "../theme";

const FALLBACK_PHOTO =
  "https://res.cloudinary.com/dqcsk8rsc/image/upload/v1577268053/avatar-1-bitmoji_upgwhc.png";

const setSignButtonText = (text) => {
  const el = document.getElementById("sign-button");
  if (el) el.innerHTML = text;
};

const LoginProfile = (props) => {
  const user = useContext(UserContext);
  const { photoURL, displayName, email } = user;

  global.config.uid = user.uid;
  global.config.accountCreated = true;
  setSignButtonText("Hello " + (displayName || "there"));

  return (
    <Box sx={{ px: 2, py: { xs: 4, md: 8 }, display: "flex", justifyContent: "center" }}>
      <Card sx={{ width: "100%", maxWidth: 440 }}>
        <CardContent sx={{ p: { xs: 3, md: 4 }, textAlign: "center" }}>
          <Avatar
            src={photoURL || FALLBACK_PHOTO}
            alt={displayName || "Profile photo"}
            sx={{ width: 96, height: 96, mx: "auto", mb: 2 }}
          />
          <Typography variant="h5">{displayName}</Typography>
          <Typography variant="body2" sx={{ color: palette.textSecondary, mb: 3 }}>
            {email}
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            <Button
              fullWidth
              size="large"
              variant="contained"
              color="secondary"
              startIcon={<Dashboard />}
              onClick={() => props.history.push("/")}
            >
              Go to Dashboard
            </Button>
            <Button
              fullWidth
              size="large"
              variant="outlined"
              color="error"
              startIcon={<ExitToApp />}
              onClick={() => {
                auth.signOut();
                setSignButtonText("Sign In");
              }}
            >
              Sign out
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default withRouter(LoginProfile);
